/** Match fund abbreviation from URL/defaults to canonical value in funds list. */
export const resolveFundAbbreviation = (funds, abbr) => {
  if (!abbr || abbr === "ALL") return abbr;
  if (!funds?.length) return abbr;

  const exact = funds.find((f) => f.abbreviation === abbr);
  if (exact) return exact.abbreviation;

  const normalized = String(abbr).toLowerCase();
  const match = funds.find(
    (f) => String(f.abbreviation).toLowerCase() === normalized
  );
  return match?.abbreviation ?? abbr;
};

export const fundAbbreviationsMatch = (a, b) =>
  String(a ?? "").toLowerCase() === String(b ?? "").toLowerCase();
